import { render, staticRenderFns } from "./activesApply.vue?vue&type=template&id=4bc9908d&scoped=true&"
import script from "./activesApply.vue?vue&type=script&lang=js&"
export * from "./activesApply.vue?vue&type=script&lang=js&"
import style0 from "./activesApply.vue?vue&type=style&index=0&id=4bc9908d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9908d",
  null
  
)

export default component.exports